const STORAGE_STATE_KEY = 'farmigoStoreState';
const STORAGE_TIMESTAMP_KEY = 'farmigoStoreTimestamp';
const STORAGE_DRAFT_ORDER_KEY = 'farmigoDraftOrder';

export function getStateFromStorage(){
    try {
        const timestamp = sessionStorage.getItem(STORAGE_TIMESTAMP_KEY);
        if (!timestamp)
            return {};

        const now = new Date().getTime();

        //Check if was set in more than 10 minutes
        if ((now - timestamp) > 10 * 60 * 1000) {
            sessionStorage.removeItem(STORAGE_STATE_KEY);
            sessionStorage.removeItem(STORAGE_TIMESTAMP_KEY);
            return {};
        }

        let state = sessionStorage.getItem(STORAGE_STATE_KEY);
        if (!state) {
            sessionStorage.removeItem(STORAGE_TIMESTAMP_KEY);
            return {}
        }

        sessionStorage.removeItem(STORAGE_STATE_KEY);
        sessionStorage.removeItem(STORAGE_TIMESTAMP_KEY);
        state = JSON.parse(state);
        state.storage.timestamp = undefined;
        state.fetching = {};
        //In case of thank-you page don't show the dirty message
        if (window.location.pathname.includes("/thankyou"))
            state.orderStatus = {};
        return state;
    }catch (e){
        return {};
    }
}

export function setStateInStorge(state, timestamp){
    try {
        //Avoid multiple calls to save
        if (sessionStorage.getItem(STORAGE_TIMESTAMP_KEY) == timestamp)
            return;
        sessionStorage.setItem(STORAGE_STATE_KEY, JSON.stringify(state));
        sessionStorage.setItem(STORAGE_TIMESTAMP_KEY, timestamp);
    }catch (e){}
}

export function clearStorage(){
    try {
        sessionStorage.removeItem(STORAGE_STATE_KEY);
        sessionStorage.removeItem(STORAGE_TIMESTAMP_KEY);
    }catch (e){}
}

export function setDraftOrderInStorage(order) {
    const now = new Date().getTime();
    sessionStorage.setItem(STORAGE_DRAFT_ORDER_KEY, JSON.stringify({timestamp: now, order}));
}

export function getDraftOrderFromStorage() {
    try {
        const draftOrder = sessionStorage.getItem(STORAGE_DRAFT_ORDER_KEY);
        if (!draftOrder) {
            return null;
        }

        const {timestamp, order} = JSON.parse(draftOrder);

        const now = new Date().getTime();

        //Check if was set in more than 10 minutes
        if ((now - timestamp) > 10 * 60 * 1000) {
            sessionStorage.removeItem(STORAGE_DRAFT_ORDER_KEY);
            return null;
        }

        sessionStorage.removeItem(STORAGE_DRAFT_ORDER_KEY);
        return order;
    }catch (e){
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/common/storage.js